<template>
  <div class="container-fluid">

    <div class="mb-2">
      <b-card class="filtre-direccio"> 
        <b-row>
          <b-col lg="3" md="10" sm="12">
            <b-form-group id="input-group-2" label="Mes: " label-size="sm" label-for="input-filtre-mes" label-cols="4">
              <b-form-select size="sm" id="input-filtre-mes" v-model="filtre.mesAny" >
                <template v-for="(item,idx) in mesosAny">
                  <b-form-select-option v-bind:key='"mes-any"-idx' :value=item>{{parseMesAny(item)}}</b-form-select-option>
                </template>  
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col lg="3" md="10" sm="12">
            <VariableRegioSanitaria v-bind:initialValue=null  v-on:variable-editada="onVariableFiltreEditada" v-on:variable-eliminada="onVariableFiltreEliminada" />
          </b-col> 
          <b-col lg="3" md="10" sm="12">
            <b-form-group id="input-group-2" label="Enquesta: " label-size="sm" label-for="input-filtre-enquesta" label-cols="4">
              <b-form-select size="sm" id="input-filtre-enquesta" v-model="filtre.idEnquesta" >
                <b-form-select-option :value=null>-- Totes --</b-form-select-option>
                <template v-for="(item,idx) in enquestes">
                  <b-form-select-option v-bind:key='"enq"-idx' :value=item.idEnquesta>{{item.descripcio}}</b-form-select-option>
                </template>
              </b-form-select>
            </b-form-group>
          </b-col> 
          <b-col lg="3" md="10" sm="12">
            <b-button size="sm" variant="outline-primary" @click.prevent="calcularGrafic()">
              <b-icon icon="filter" aria-hidden="true"></b-icon>
            </b-button>
          </b-col>          
        </b-row>
      </b-card>
      <b-card class="llegenda-indicador-positiu">
        <b-row>
          <b-col lg="2" md="10" sm="12" />
          <b-col lg="6" md="10" sm="12">
            <LlegendaIndicadorPositiu />
          </b-col>
          <b-col lg="2" md="10" sm="12" />
        </b-row>
      </b-card>

      <div class="text-center mt-4" v-if="loadingDataCharts"><b-spinner variant="primary" ></b-spinner></div>
      <b-row no-gutters v-if="!loadingDataCharts">      

      <b-col xl="12" lg="12" md="12" sm="12" xs="12" v-for="(item,idx) in filtre.charts" v-bind:key='idx-lastCercaTime'>           
            <DistributionChart :id="`distribution-chart-${idx}`" :titol="item.titol | etiqueta" :index=item.index :tipus=item.tipus :class="'distribution-chart'" 
            v-if='item.tipus.includes("distribution-chart")' :dades=item.dades />
      </b-col>         

      </b-row>

    </div>
  </div>
</template>

<script>
import DistributionChart from "../charts/DistributionChart";
import enquestaService from "../../services/EnquestaService";
import VariableRegioSanitaria from "./VariableRegioSanitaria";
import LlegendaIndicadorPositiu from "./LlegendaIndicadorPositiu";
export default {
  name: "direccio",
  components: {
    DistributionChart,
    VariableRegioSanitaria,
    LlegendaIndicadorPositiu
  },  
  data() {
    return {
      enquestes: [],
      mesosAny: [],
      loadingDataCharts: true,
      filtre:{ 
        idEnquesta:null,
        mesAny:null,
        regions:[],
        config: {},
        charts: [],
        totalRespostes: 0,
        totalEnquestats: 0
      }
    };
  },
  methods: {
     async listFiltreEnquestesDireccio() {      

        try{
          
          this.enquestes = [];
          this.mesosAny = [];
          const response = await enquestaService.listFiltreEnquestesDireccio({});
          
          for(var i = 0;i<response.data.length;i++){
            var e = response.data[i];
          
            for(var j = 0;j<e.mesos.length;j++){
              let mesAny = e.mesos[j];
              
              if(!this.mesosAny.includes(mesAny)){
                this.mesosAny.push(mesAny);
              }
            }
            this.enquestes.push(e);
          }          
          this.mesosAny.sort();
          
          this.filtre.mesAny = this.mesosAny[this.mesosAny.length-1];

          this.cercaResultatsDireccio();
        }catch(e){
          console.log(e);
        }      

    },
     async cercaResultatsDireccio(){
        try{
          this.filtre.config.disaggregatedQuestions = [];
          this.filtre.config.onlyTheFirstSubmitsByQuota=false;
          this.filtre.config.submitsByQuota=true;
          //TODO PROBAR
          this.filtre.config.ignoredOptionsDonutsChart=["9"];
          this.filtre.config.ignoredAnswersDonutsChart=["No vaig estar a la llista d’espera"];

          if(!this.filtre.idEnquesta){
           this.filtre.config.disaggregatedQuestions = [6,7];
          }

          this.loadingDataCharts = true;
          const response = await enquestaService.getResultatsDireccio(this.filtre);
          this.filtre = response.data;
          this.lastCercaTime = new Date().getTime();
          this.loadingDataCharts = false;
        }catch(e){
          console.log(e);
        }  
     },
    onVariableFiltreEditada(evt){

      
      if(!this.filtre.regions){
        this.filtre.regions = [];
        this.filtre.regions.push(evt);
      }else{
        if(this.filtre.regions.filter(v=>v.codi ===evt.codi).length>0){
          this.filtre.regions.filter(v=>v.codi ===evt.codi)[0].valor = evt.valor;
        }else{
          this.filtre.regions.push(evt);
        } 
      }
      
    },
    onVariableFiltreEliminada(codi){
      if(this.filtre.regions){
        this.filtre.regions = this.filtre.regions.filter(v=>v.codi != codi);
      }
    },
    parseMesAny(mesAny){
        let meses = ["Gener", "Febrer", "Març", "Abril", "Maig", "Juny", "Juliol", "Agost", "Setembre", "Octubre", "Novembre", "Decembre"];

        let response = mesAny;
        let aMesAny = mesAny.split("-");

        if(aMesAny.length > 1){
          response = meses[parseInt(aMesAny[1])-1]+" "+aMesAny[0];
        }

      return response;
    },
    calcularGrafic(){
      this.loadingDataCharts = true;
      this.cercaResultatsDireccio();
    }
  },
  mounted() {
      this.listFiltreEnquestesDireccio();
  }
};
</script>

<style>
</style>